/*
 * 档口管理设置
 *
 * @Author: fan.li@zuolin.com
 * @Date: 2019-07-30 19:45:01
 * @Last Modified by: fan.li@zuolin.com
 * @Last Modified time: 2019-08-06 20:53:58
 */

const api = {
	listStalls: '/stall/listStalls',  //查询档口列表
	listPrinters: '/printer/listPrinters', // 查看打印机列表
	addStall: '/stall/addStall',  // 新增档口
	updateStall: '/stall/updateStall',  // 编辑档口
	deleteStall: '/stall/deleteStall', //删除档口
	getStall: '/stall/getStall', //查询档口
	getDistributionPrintFlag: '/store/getDistributionPrintFlag', //查看分菜品打印开关状态
	distributionPrintSwitch: '/store/distributionPrintSwitch', //分菜品打印开关控制
	verificationOrder: '/cashRegisterOrder/verificationOrder', //核销
	testPrinterByStall: '/stall/testPrinterByStall',  // 档口打印测试
};

const routes = {
	'/shopitem-manage': '档口管理'
};

export {
	api,
	routes,
};
